<template>
  <v-autocomplete
    :hide-details="hideDetails"
    :items="knownProjectSelectables"
    :value="value"
    :loading="loading || internalLoading"
    :disabled="disabled || internalLoading"
    class="select"
    item-text="name"
    return-object
    overflow
    label="Projekt"
    @input="onInput"
  />
</template>

<script>
import { api, endpoints } from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalLoading () {
      return this.knownProjectSelectablesLoading
    },
    ...mapGetters(['knownProjectSelectables', 'knownProjectSelectablesLoading']),
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
  }
}
</script>
